import { z } from 'zod';
import { id } from '../../../common/atomic/id';
import { dateTime } from '../../../common/atomic/dateTime';
import { date } from '../../../common/atomic/date';
import { pageableRequestSchema } from '../../pageable/request';

export const absenceSchema = z.object({
  id,
  start: date,
  end: date,
  name: z.string(),
  note: z.string(),
  confirm: z.object({
    empId: id,
    empFirstName: z.string(),
    empLastName: z.string(),
    at: dateTime,
  }),
});

export const absencesSchema = z
  .object({
    content: z.array(absenceSchema),
  })
  .merge(pageableRequestSchema);

export type Absence = z.infer<typeof absenceSchema>;
export type Absences = z.infer<typeof absencesSchema>;
